<template>
    <div>
        <v-row>
            <div class="title-wrapper">
                <span class="display-1 font-weight-medium">{{ stage.name.toUpperCase() }}</span>
            </div>
        </v-row>
        <v-row class="hidden-sm-and-down">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="col-10 col-md-6">
                <step-multi
                    :selected="parseInt(sort)"
                    :questions="sections"
                    :stageKey="stage.key"
                />
            </v-col>
            <v-col class="col-1 col-md-3"></v-col>
        </v-row>
        <v-row>
            <v-col class="col-1 col-md-4"></v-col>
            <v-col class="col-10 col-md-4">
                <router-view></router-view>
            </v-col>
            <v-col class="col-1 col-md-4"></v-col>
        </v-row>
    </div>
</template>
<script>
import { stages } from '../db/testdb.js';
import StepMulti from "./StepMultiComponent";

export default {
    props: {
        sectionCount: Number
    },
    components: {
        StepMulti,
    },
    data: function() {
        return {
            sort: null,
            sections: [],
            stage: null
        }
    },
    watch: {
        '$route.meta.sort': function (sort) {
            this.sort = sort
        }
    },
    beforeMount: function() {
        this.stage = stages.find(x => x.key === 'profile');
        this.sort = this.$route.meta.sort;

        for (let i = 0; i < this.sectionCount; i++) {
            this.sections[i] = { sort: i + 1 };
        }
    }
}
</script>
